import FEEDBACKCOMPLAINTSTATE from './feedback-complaint/state'

const state = {
  showMenuResponsive: false,
  loading: false,

  AppActiveUser: null,
  RoleIdUser: null,
  permissions: null,

  ...FEEDBACKCOMPLAINTSTATE
}

export default state
